<template>
  <div
    ref="main"
    class="main"
    data-testid="base-layout"
  >
    <slot name="sidebar" />

    <main
      class="main-content"
      :class="typeClass"
    >
      <slot />
    </main>
  </div>
</template>

<script>
export default {
  name: 'BaseLayout',
  props: {
    background: {
      type: String,
      default: 'primary',
      validator(value) {
        return ['primary', 'secondary'].includes(value)
      }
    }
  },
  computed: {
    typeClass() {
      return `main-content--${this.background}`
    }
  }
}
</script>

<style lang="scss" scoped>
$side-bar-width: 133px;

.main {
  position: relative;
  padding-left: var(--sidebar-width, #{$side-bar-width});
  height: 100%;
  background: var(--color-white);

  .main-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: auto;
    min-height: 100%;

    &.main-content--primary {
      background-color: var(--color-white);
    }

    &.main-content--secondary {
      background-color: var(--color-zinc-50);
    }
  }
}

@include phone {
  .main {
    flex-direction: column-reverse;
    padding-left: 0;

    @include only-safari {
      height: -webkit-fill-available;
    }
  }
}
</style>
